import React, {useRef, useEffect} from "react";
import Header from "../components/Header";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import mapboxgl from 'mapbox-gl'

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../components/Footer";
import Search from "../components/Search";
import {useModal} from "../components/ModalContext";
import TypingEffect from "../components/TypingEffect/TypingEffect";
import MediaArticles from "../components/MediaArticles/MediaArticles";

let img_play = require("../assets/home/play-button-icon.png");
let promo_fungo = require("../assets/home/promo-fungo.png");
let promo_experience = require("../assets/home/promo-experience.png");
let promo_map = require("../assets/home/promo-map.png");
let promo_experience2 = require("../assets/home/promo-experience2.png");
let promo_community = require("../assets/home/promo-community.png");
let promo_society = require("../assets/home/promo-society.png");
let promo_society2 = require("../assets/home/promo-society2.png");
let promo_feedback = require("../assets/home/promo-feedback.png");

let img_card_tickets = require("../assets/home/card-tickets.png");

let img1 = require("../assets/home/funghi.jpg");

function Home() {
    const {openModal} = useModal();

    const mapRef = useRef()
    const mapContainerRef = useRef()


    /*    useEffect(() => {

            mapboxgl.accessToken = 'pk.eyJ1IjoiZ2VvdGlja2V0c3JsIiwiYSI6ImNsenFvcmh1dzF0bDgyanFyd3lhaGhtNWMifQ.Lt-gOko0rO-VuTBu3kKD1w'
            mapRef.current = new mapboxgl.Map({
                container: mapContainerRef.current,
                center: [12.2558141, 41.9097306],
                zoom: 5
            });

            return () => {
                mapRef.current.remove()
            }
        }, [])*/

    function renderCardsVideo() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<Col xs={12} md={3} className="p-2">
                <div className="video-community ">
                    <video autoPlay loop muted>
                        <source src={require("../assets/home/video_home_1.mp4")} type="video/mp4"/>
                        Il tuo browser non supporta il video.
                    </video>
                </div>
            </Col>);
        }
        return result;
    }

    function renderCardsTickets() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<Col xs={12} md={3} className="p-2">
                <div className="card card-ticket">
                    <img className="card-img-top" src={img1} alt="Card image cap"/>
                    <div className="card-body ">
                        <span>Funghi - Annuale</span><br/>
                        <span>Comunita' Montana di Valle Camonica</span><br/>
                        <span>Piazza Tassara Lombardia, Italia</span><br/>
                        <span>Tutti</span><br/>
                        <span>01/01/2024 - 31/12/2024</span><br/>
                        <span>80.00€</span><br/>
                        <div className={"mx-auto"}>
                            <a href="#" className="btn btn-success">Acquista</a>
                        </div>
                    </div>
                </div>
            </Col>);
        }
        return result;
    }

    return (
        <div style={{backgroundColor: "#fafafa"}}>
            <Header/>
            <Search/>
            <div className="video-section">
                <video autoPlay loop muted className="background-video">
                    <source src={require("../assets/home/video_home_1.mp4")} type="video/mp4"/>
                    Il tuo browser non supporta il video.
                </video>

                {/* Sovrapposizione di pulsanti */}
                <div className="overlay-content background">
                    <div>
                        <img className={"image-play"} src={img_play} alt="Card image cap"/>

                        <div style={{flex: 1}}>
                            <h1 className="title">Se vai a <TypingEffect texts={["funghi", "pesca", "sci"]}/><br/><b>sei
                                nel posto giusto</b></h1>
                        </div>
                        <div className="buttons">
                            <Button className={"btn-orange"}>Tabella crescita funghi</Button>
                            <Button className={"btn-orange"} onClick={() => openModal()}>Acquista
                                permessi</Button>
                            <Button className={"btn-orange"}>Prenota esperienze</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"container-promo"}>
                    <div style={{backgroundImage: `url(${promo_fungo})`}} className="background-container">
                        <h3>Tabella crescite<br/><b>intelligente</b></h3>
                        <span>Scopri dove stanno nascendo</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"}>Scopri di più</Button>
                        </div>
                    </div>
                    <div style={{backgroundImage: `url(${promo_experience})`}} className="background-container">
                        <h3>Geoticket<br/><b>experience</b></h3>
                        <span>Regala o prenota le migliori esperienze all’aperto</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"}>Prenota ora</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"background  mt-2"} style={{backgroundImage: `url(${img_card_tickets})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Acquista il tuo permesso</h4>
                        <p>Sei indeciso? ecco alcuni suggerimenti...</p>
                    </div>
                    <Row>
                        {renderCardsTickets()}
                    </Row>
                    <Button className={"btn-orange"} onClick={() => openModal()}>ACQUISTA IL TUO PERMESSO</Button>
                </div>
            </div>

            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_map})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Scopri dove stanno nascendo</h4>
                        <p>Abbiamo creato per te una mappa intelligente,
                            che incrocia milioni di dati ambientali per prevedere
                            le prossime nascite.</p>
                    </div>
                    <div style={{height: 240}}></div>
                    <Button className={"btn-orange"}>PROVALA SUBITO</Button>
                </div>
            </div>
            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_experience2})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Regalati un’esperienza all’aperto</h4>
                        <p>Abbiamo selezionato per te le migliori esperienze di raccolta funghi in Italia</p>
                    </div>
                    <div style={{height: 240}}></div>
                    <Button className={"btn-orange"}>PRENOTA ORA</Button>
                </div>
            </div>

            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_community})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Entra nella nostra community</h4>
                        <p>Condividi con noi i tuoi video: li pubblicheremo sui nostri canali!</p>
                    </div>
                    <Row>
                        {renderCardsVideo()}
                    </Row>
                    <Button className={"btn-orange"}>ISCRIVITI SUBITO</Button>
                </div>
            </div>

            <div className={"container"}>
                <div className={"container-promo"}>
                    <div style={{backgroundImage: `url(${promo_society})`}} className="background-container">
                        <h3>Gestisci <b>un Ente?</b></h3>
                        <span>Scopri come vendere i tuoipermessi e ticket con un click</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"}>CONTATTACI</Button>
                        </div>
                    </div>
                    <div style={{backgroundImage: `url(${promo_society2})`}} className="background-container">
                        <h3>Hai<b>un’attività commerciale?</b></h3>
                        <span>Vendi permessi e ticket direttamente dal tuo punto vendita</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"}>CONTATTACI</Button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_feedback})`}}>
                <div className={"container-list"}>
                    <div className={"container-title"}>
                        <h4>Dicono di noi...</h4>
                    </div>
                    <div style={{height: 240}}></div>

                    <div className={"container"}>
                    <MediaArticles/>

                </div>
                </div>
            </div>
            {/*
            <div style={{width: '100%', height: 420, position: 'relative'}}>
                <div id='map-container' className={"map"} ref={mapContainerRef}/>
                <div className="map-overlay">
                    <h4>scopri dove stanno nascendo</h4>
                    <span>La nostra mappa intelligente incrocia milioni di dati ambientali per prevedere le prossime nascite. <br/>Provala subito!</span>
                </div>
            </div>*/}

            <Footer/>
        </div>
    );
}

export default Home;